






































import Vue, { PropType } from "vue";
import "@/components/icons";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import CustomButton from "@/components/Atoms/Button/index.vue";
import { addFollowUniversities, getFollowsUniversities } from "@/api";
import { ApiResponse } from "@/api/types";

export interface Data {
  followedUniversities: ApiResponse.FollowsUniversities["universities"];
  loading: {
    fetchingFollowedUniversities: boolean;
    addingUniversity: boolean;
  };
}

export interface Computed {
  isFollow: boolean | undefined;
}

export interface Props {
  university: Application.University;
}

export interface Methods {
  handleClickSubmit: () => void;
  getFollowUniversities: () => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FollowUniversityFloatingView",
  components: {
    Overlay,
    FloatingView,
    Heading,
    CustomButton
  },
  props: {
    university: {
      type: Object as PropType<Props["university"]>,
      required: true
    }
  },
  data() {
    return {
      followedUniversities: [],
      loading: {
        fetchingFollowedUniversities: false,
        addingUniversity: false
      }
    };
  },
  computed: {
    isFollow() {
      if (!this.followedUniversities) {
        return;
      }

      return this.followedUniversities.some(
        followedUniversity => followedUniversity.id === this.university.id
      );
    }
  },
  mounted() {
    this.getFollowUniversities();
  },
  methods: {
    async getFollowUniversities() {
      try {
        this.$set(this.loading, "fetchingFollowedUniversities", true);
        const { data } = await getFollowsUniversities();
        this.followedUniversities = data.universities;
      } finally {
        this.$set(this.loading, "fetchingFollowedUniversities", false);
      }
    },
    async handleClickSubmit() {
      try {
        this.$set(this.loading, "addingUniversity", true);
        await addFollowUniversities({
          university_ids: [this.university.id]
        });
      } finally {
        this.$set(this.loading, "addingUniversity", false);
      }
      this.$emit("close");
    }
  }
});
